import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { query, paginate } from '../../../lib/loopback'

const tarefaRepository = createRepository({
  path: 'tarefa',
  restApi,
  queryTransform: {
    createdAt: query.gte('createdAt'),
    dataTermino: query.gte('dataTermino'),
    createdAtFim: query.lte('createdAtFim'),
    dataTerminoFim: query.lte('dataTerminoFim'),
    placaCavalo: query.likeAlphaDigits('placaCavalo'),
    cpfMotorista: query.likeDigits('cpfMotorista'),
    ...paginate
  }
})

const _create = tarefaRepository.create
tarefaRepository.create = async (data, options) => {
  const formData = new FormData()
  Object.keys(data)
    .filter(k => k !== 'data')
    .forEach(key => formData.append(key, data[key]))
  formData.append('data', JSON.stringify(data.data))
  return _create(formData, {
    ...options,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    }
  })
}

tarefaRepository.reanaliseEmbarcador = (id, data) => {
  return restApi.post(`tarefas/${id}/reanaliseEmbarcador/`, data)
}

export const tarefaOperacaoRepository = {
  operacaoKmm: operacao => {
    return restApi.get(`tarefa/operacao-kmm/${operacao}`)
  }
}

export default tarefaRepository
